import { render, staticRenderFns } from "./group-push.vue?vue&type=template&id=9adbe172&lang=pug&"
import script from "./group-push.vue?vue&type=script&lang=js&"
export * from "./group-push.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports